module.exports = __webpack_public_path__ + "static/img/JayClark.6a8b293.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JayClark.jpg
// module id = dRB3
// module chunks = 0